export default __webpack_public_path__ + "static/Rectangle4386-0db4d6a8fa1bbcc0e96e85c897e0f95a.png";